import { Component, OnInit, ViewChild } from '@angular/core';
import * as ngComponents from '@po-ui/ng-components';
import { UtilService } from 'src/app/services/util-service/util.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DicionarioService } from 'src/app/services/dicionario/dicionario.service';
import { BrowserService } from 'src/app/services/browser/browser.service';
import { Router } from '@angular/router';
import { LegendaService } from 'src/app/services/legenda/legenda.service';
import { SessionService } from 'src/app/services/session/session.service';
import { environment } from 'src/environments/environment';
import { UploadService, UploadSucess } from 'src/app/services/upload/upload.service';
import { PreNotaPedidosService } from 'src/app/services/pre-nota-pedidos/pre-nota-pedidos.service';
import { PoDialogService, PoUploadComponent, PoUploadFileRestrictions } from '@po-ui/ng-components';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-pre-nota-list',
  templateUrl: './pre-nota-list.component.html',
  styleUrls: ['./pre-nota-list.component.css']
})
export class PreNotaListComponent implements OnInit {

  uploadURL = `${environment.protheus}/upload`;
  fileRestrictions: PoUploadFileRestrictions = { allowedExtensions: ['.pdf', '.xml'] };
  
  public incluiNota = true;
  public mensagemNota = "";

  @ViewChild('anexoModal', { static: true }) anexoModal: ngComponents.PoModalComponent;
  @ViewChild('mensagemInclusao', { static: true }) mensagemInclusao: ngComponents.PoModalComponent;

  @ViewChild('upload', { static: true }) upload: PoUploadComponent;
  @ViewChild('mensagemGov', { static: true }) mensagemGov: ngComponents.PoModalComponent;


  public page: ngComponents.PoPageDefault = {
    title: 'Nota Fiscal',
    breadcrumb: {
      items: [
        { label: 'Home' },
        { label: 'Nota Fiscal' },
      ] as ngComponents.PoBreadcrumbItem[]
    } as ngComponents.PoBreadcrumb,
    actions: [
      {
        label: 'Incluir NF', icon: 'po-icon-plus', separator: true, action: () => { 
          if (this.incluiNota) {
            this.router.navigate(['nota-fiscal/add']);
            return;
          }
          
          this.mensagemInclusao.open();
        },
      },
      {
        label: 'Alterar', icon: 'po-icon po-icon-edit', separator: true, action: () => {
          if (this.isSelected()) {
            this.router.navigate(['nota-fiscal/edit', this.preNotaSelecionada.REGISTRO]);
          }
        }
      },
      {
        label: 'Visualizar', icon: 'po-icon po-icon-zoom-in', separator: true, action: () => {
          if (this.isSelected()) {
            this.router.navigate(['nota-fiscal/view', this.preNotaSelecionada.REGISTRO]);
          }
        }
      }, {
        label: 'Excluir', icon: 'po-icon-delete', separator: true, action: () => {
          if (this.isSelected()) {
            this.router.navigate(['nota-fiscal/delete', this.preNotaSelecionada.REGISTRO]);
          }
        }
      }
    ]
  };

  public tableColumns: Array<ngComponents.PoTableColumn> = [];
  public tableItems = [];
  public tableHeight = 0;
  private preNotaSelecionada: any;
  public loading = false;
  private legenda: Array<ngComponents.PoTableSubtitleColumn> = [];
  public arrFields: any[];
  public options = {};
  public fieldsModal: ngComponents.PoTableColumn[];
  public informacoes: any;
  public informacoesFornecedor = '';
  selects = {
    cores: [] as Array<ngComponents.PoSelectOption>
  };

  public pagination = {
    itemsPerPage: 50,
    totalItems: 0,
    currentPage: 1
  };

  public tableConhecimentoColumns: Array<any> = [];
  public tableConhecimentoItems = [];
  public mostrarArquivos = false;
  public labelButton = 'Exibir Arquivos';
  // private codigoAcesso = '';
  public allItens = false;
  public item: any[] = [];

  filtros = {
    F1_DOC: '',
    F1_SERIE: '',
    F1_EMISSAO: ''
  };

  constructor(
    private utilService: UtilService,
    private notificationService: ngComponents.PoNotificationService,
    private dicionarioService: DicionarioService,
    private browserService: BrowserService,
    private router: Router,
    private legendaService: LegendaService,
    private sessionService: SessionService,
    private uploadService: UploadService,
    private preNotaService: PreNotaPedidosService,
    private poDialog: PoDialogService
  ) { }

  ngOnInit(): void {
    this.sessionService.info$
      .subscribe((data: any) => {
        this.informacoes = data;
        this.incluiNota = data.incluiNota;
        this.mensagemNota = data.mensagemNota;
        if (this.mensagemNota) {
          this.mensagemInclusao.open()
        }
      });

    this.informacoesFornecedor = ` Informações do Cabeçalho  CNPJ: ${this.informacoes.FORNECEDOR[0].A2_CGC} - NOME: ${this.informacoes.FORNECEDOR[0].A2_NOME}`;

    this.getLegenda('prnf', 'SF1');
  }


  public selected(event) {
    this.preNotaSelecionada = event;
  }

  public unSelected(event) {
    this.preNotaSelecionada = {};
  }

  private isSelected() {
    if (this.preNotaSelecionada == null || this.preNotaSelecionada === '') {
      this.notificationService.warning('Selecione uma Nota Fiscal !');
      return false;
    } else {
      return true;
    }
  }

  private getDicionario() {
    this.loading = true;
    const param = {
      // codigo: this.codigoAcesso
      tabela: 'SF1'
    };
    this.dicionarioService
      .fsbDicionario(this.utilService.getParameters(param))
      .subscribe((data: any) => {
        let auxiliarColumns: Array<any> = data.dados[0].dynamicView[0].fields;

        auxiliarColumns = auxiliarColumns.filter(item => item.browse === true);

        auxiliarColumns.sort((a, b) => a.sequence - b.sequence)

        this.arrFields = [];
        this.tableColumns = auxiliarColumns.map((item) => {
          if (item.option.length > 0) {
            this.options[item.property] = [];
            const arr: Array<string> = item.option.split(';');
            this.options[item.property] = arr.map((opt) => {
              const d = opt.split('=');
              return { value: d[0], label: d[1] } as ngComponents.PoSelectOption;
            });
          }

          let pixels: number = parseInt(item.width, 10) * 25;
          if (pixels <= 125) {
            pixels = 125;
          } else if (pixels > 200) {
            pixels = 200;
          } else {
            pixels = parseInt(item.width, 10) * 25;
          }

          let obj: ngComponents.PoTableColumn = {};

          let typeTable = '';
          let formatTable = '';

          if (item.TIPO === 'D') {
            typeTable = 'date';
            formatTable = 'dd/MM/yyyy';
          } else if (item.TIPO === 'N') {
            obj.type = 'number';
          }

          obj = { label: item.label, property: item.property, width: `${pixels}px`, type: `${typeTable}`, format: `${formatTable}` };

          return obj;
        });

        this.tableHeight = this.utilService.calcularHeight(innerHeight, 0.45);
        this.tableColumns.unshift({
          label: 'Anexar NF/Pedido', property: 'actions', width: '160px', type: 'icon', icons: [
            {
              action: this.anexarDocumento.bind(this),
              tooltip: 'Anexar NF/Pedido',
              icon: 'po-icon po-icon-document-filled',
              value: 'file'
            }
          ]
        });
        this.tableColumns.unshift({ label: '-', property: 'COR', width: '50px', type: 'subtitle', subtitles: this.legenda });
        this.getPreNota();

        // this.loading = false;
      },
        (error: HttpErrorResponse) => {
          this.notificationService.error('Error ao carregar os dados!');
          console.log(error.error);
          this.loading = false;
        });
  }

  public anexaArquivo(event) {
    this.uploadService.uploadHandler(event, {
      arquivo: event.file.name,
      extensao: event.file.extension,
      aliasTabela: 'SF1',
      registro: this.preNotaSelecionada.REGISTRO,
    });
    setTimeout(() => {
      this.retornaFiles(this.preNotaSelecionada.REGISTRO);
    }, 2000);
  }

  private getPreNota(tabela?: string) {
    this.tableItems = [];
    const obj = {
      pagina: this.pagination.currentPage,
      itenspagina: this.pagination.itemsPerPage,
      tabela: 'SF1',
      rotina: 'prnf',
      cnpj: this.informacoes.FORNECEDOR[0].A2_CGC
    };
    this.browserService
      .fsbBrowser(this.utilService.getParameters(obj))
      .subscribe((data: any) => {

        this.tableItems = Object.values(data);
        this.tableItems = this.tableItems[0];

        this.tableItems.map((item) => {
          Object.keys(this.options).map((opt) => {
            if (opt in item) {
              const options = this.options[opt].find(element => element.value === item[opt]);
              item[opt] = options === undefined ? '' : options.label;
            }
          });
        });

        this.tableItems
          .map((item) => {
            const element = item;
            element.actions = ['file'];
          });

        this.loading = false;
        this.pagination.totalItems = data.total;
      },
        (error) => {
          this.notificationService.error(`Erro ao carregar os dados : ${error.errorMessage}`);
          console.error(error);
          this.loading = false;
        });
  }

  private getLegenda(rotina: string, tabela: string) {
    this.loading = true;
    this.legendaService
      .getLegenda(rotina, tabela)
      .subscribe((data) => {
        this.legenda = data.dados.map((item) => {
          this.selects.cores.push({ label: item.descricao, value: item.status });
          return {
            label: item.descricao,
            value: item.cor,
            color: item.cor, content: ''
          } as ngComponents.PoTableSubtitleColumn;
        });

        this.getDicionario();
      },
        (error: HttpErrorResponse) => {
          this.loading = false;
        });
  }

  public onPageChange(event: number) {
    this.pagination.currentPage = event;
    this.getPreNota();
  }

  public retornaFiles(registro: any) {
    this.loading = true;
    this.uploadService.listFiles('SF1', registro)
      .subscribe((data: any) => {
        this.tableConhecimentoColumns = [
          { property: 'descricao', label: 'Nome Arquivo', width: '80%' },
        ];
        this.tableConhecimentoItems = data.arquivos;
        this.tableConhecimentoItems.map((item) => {
          item.actions = ['baixar', 'remover'];
        });
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        console.error(err);
        this.notificationService.error('Não foi possível recuperar os arquivos desta Nota Fiscal, por favor tente novamente');
      });
  }

  exibeFiles() {
    this.mostrarArquivos = !this.mostrarArquivos;
    if (this.mostrarArquivos === true) {
      this.labelButton = 'Ocultar Arquivos';
    } else {
      this.labelButton = 'Exibir Arquivos';
    }
  }

  fakeDownload(item) {
    this.uploadService.downloadFile(item.recno)
      .subscribe((data: any) => {
        const blob = new Blob([data],);
        const url = window.URL.createObjectURL(blob);
        console.log(blob);
        const el = document.createElement('a');
        el.href = url;
        el.download = item.descricao;
        document.body.append(el);
        el.click();
        this.notificationService.success('Arquivo baixado com sucesso!');
      });
  }

  fakeRemove(item) {
    const itens = this.tableConhecimentoItems.filter((data) => {
      return data.descricao !== item.descricao;
    });
    this.tableConhecimentoItems = itens;
    this.notificationService.success('Item deletado com sucesso!');
  }

  uploadError(err: HttpErrorResponse) {
    console.log(err);
    if (err.ok === false) {
      this.poDialog.alert({
        title: `Erro ao anexar documento`,
        message: err.error.errorMessage,
        ok: () => ('')
      });
      this.loading = false;
    }
  }

  uploadSucess(ret: UploadSucess) {
    console.log(ret);
  }

  downloadFiles() {
    console.log(this.item);
    const arr = this.item.map((ret,index) => {
      return ret[index].recno.toString();     
    });

    this.uploadService.downloadFile(arr)
      .subscribe((data: any) => {
        console.log(data);

        const blob = new Blob([data],);
        const url = window.URL.createObjectURL(blob);
        console.log(blob);
        const el = document.createElement('a');
        el.href = url;
        el.download = `${Date.now()}.zip`;
        document.body.append(el);
        el.click();
        this.notificationService.success('Arquivo baixado com sucesso!');
      });
  }

  public selectedItem(event) {
    this.allItens = false;
    this.item.push(event);
    console.log(this.item);
  }

  public unSelectedItem(event) {
    if (this.item[0].length > 0) {
      this.item = this.item[0].filter(item => item.recno !== event.recno);
    } else {
      this.item = this.item.filter(item => item.recno !== event.recno);
    }
    console.log(this.item);

  }

  allSelectedItem(event: any) {
    this.allItens = true;
    this.item.push(event);
    console.log(this.item);

  }

  unAllSelectedItem(event: any) {
    this.allItens = false;
    this.item = [];
    console.log(this.item);

  }

   public abrirMensagemGov() {

console.log("Aqui");

  this.mensagemGov.open(); 
  }

  /* Filter NF */
  public filtrarNotaFiscal() {
    this.loading = true;
    const envio = {
      cnpj: this.informacoes.FORNECEDOR[0].A2_CGC,
      F1_DOC: this.filtros.F1_DOC,
      F1_SERIE: this.filtros.F1_SERIE,
      F1_EMISSAO: this.filtros.F1_EMISSAO,
      pagina: 1,
      itensPagina: 50,
      tabela: 'SF1',
      rotina: 'PRNF',
    };

    console.log(envio);

    this.preNotaService.filtrarPreNota(envio)
      .subscribe((data: any) => {
        this.tableItems = Object.values(data);
        this.tableItems = this.tableItems[0];
        this.tableItems.map((item) => {
          Object.keys(this.options).map((opt) => {
            if (opt in item) {
              const options = this.options[opt].find(element => element.value === item[opt]);
              item[opt] = options === undefined ? '' : options.label;
            }
          });
        });
        this.pagination.totalItems = data.total;
        this.loading = false;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.error(error.error);
        this.loading = false;
      });
  }

  /* Anexar Documento */

  private anexarDocumento(item) {
    this.upload.clear();
    this.preNotaSelecionada = item;
    this.retornaFiles(item.REGISTRO);
    setTimeout(() => {
      this.anexoModal.open();
    }, 1000);
  }

}
